module.exports = __webpack_public_path__ + "static/media/u25_3.c0de2a14.mp3";